import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SignatureSharedCreateGuestSignature,
	type SignatureSharedCreateGuestSignatureMutation,
	type SignatureSharedCreateGuestSignatureMutationVariables,
} from './createAsGuest.graphql';
import { normalizeSignPetitionAsGuestResponse } from './normalizeSignPetitionAsGuestResponse';
import { normalizeSignPetitionErrorResponse } from './normalizeSignPetitionErrorResponse';
import type { SignPetitionAsGuestInput, SignPetitionAsGuestResult } from './types';

type Options = {
	signature: SignPetitionAsGuestInput;
};

export async function createGuestSignature(
	{ signature }: Options,
	{ gql: { fetch } }: UtilityContext,
): Promise<SignPetitionAsGuestResult> {
	let data: SignatureSharedCreateGuestSignatureMutation | null | undefined;
	try {
		const result = await fetch<
			SignatureSharedCreateGuestSignatureMutation,
			SignatureSharedCreateGuestSignatureMutationVariables
		>({
			query: SignatureSharedCreateGuestSignature,
			variables: {
				input: signature,
			},
			path: `/signPetition/${signature.petitionId}`,
			rejectOnError: true,
			batched: false, // to ensure this rate limited mutation is not batched
		});
		({ data } = result);
	} catch (err) {
		return normalizeSignPetitionErrorResponse(err);
	}

	return normalizeSignPetitionAsGuestResponse(data.signPetitionAsGuest);
}
